module.exports = __webpack_public_path__ + "img/vorne nacht.55d5a116.jpg";